import { Tooltip } from '@/components/ui/Tooltip'
import { cn } from '@/lib/utils'
import type { DayStatus } from '@/lib/week'

const TITLES: Record<DayStatus, string> = {
  ok: '6-10 uur',
  low: '1-5 uur (mogelijk onvolledig)',
  empty: 'Geen uren op een werkdag',
  over: 'Meer dan 12 uur (controleer)',
  none: 'Weekend',
}

export function StoplichtDot({ status, className }: { status: DayStatus; className?: string }) {
  if (status === 'none') return <span className={cn('inline-block h-2.5 w-2.5', className)} />

  return (
    <Tooltip content={TITLES[status]}>
      <span
        aria-label={TITLES[status]}
        className={cn(
          'inline-block h-2.5 w-2.5 rounded-full',
          status === 'ok' && 'bg-status-paid',
          status === 'over' && 'bg-status-overdue',
          status === 'empty' && 'border border-ink-faint/45',
          className,
        )}
        style={
          status === 'low'
            ? {
                border: '1px solid rgb(var(--status-approval-rgb))',
                background: 'linear-gradient(90deg, rgb(var(--status-approval-rgb)) 50%, transparent 50%)',
              }
            : undefined
        }
      />
    </Tooltip>
  )
}
